import { BGR_STATUS } from "../enums/background.enum";

export class IAlsdeBackground {
    uid!: string;
    isBackgroundCheckRequired?: boolean;
    portalMessage?: string;
    systemOfRecord?: string;
    statusMessage: BGR_STATUS = BGR_STATUS.NO_INFO;
    statusDate?: string;
    verfiedDate?: string;
}

export class AlsdeBackground extends IAlsdeBackground{

    constructor(obj?:IAlsdeBackground){
        super();
        if(obj){
            this.uid = obj?.uid;
            this.isBackgroundCheckRequired = obj?.isBackgroundCheckRequired;
            this.portalMessage = obj?.portalMessage;
            this.systemOfRecord = obj?.systemOfRecord;
            this.statusMessage = obj?.statusMessage;
            this.statusDate = obj?.statusDate;
        }
    }

    toJSON(){
        return {
            uid: this.uid,
            isBackgroundCheckRequired : this.isBackgroundCheckRequired,
            portalMessage : this.portalMessage,
            systemOfRecord : this.systemOfRecord,
            statusMessage: this.statusMessage,
            statusDate: this.statusDate,
            verfiedDate: this.verfiedDate
        }
    }

    setEmpty() {
        return null;
    }
}